import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection || 'column'};
  justify-content: ${props => props.justifyContent || 'flex-start'};
  padding-right: ${props => props.paddingRight && '8px'};

  @media only screen and (max-width: 850px) {
    width: 100%;
  }
  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;

export default Container;
